import { render, staticRenderFns } from "./DataPreview.vue?vue&type=template&id=50d012f0&scoped=true"
import script from "./DataPreview.vue?vue&type=script&lang=js"
export * from "./DataPreview.vue?vue&type=script&lang=js"
import style0 from "./DataPreview.vue?vue&type=style&index=0&id=50d012f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d012f0",
  null
  
)

export default component.exports